import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, MapPin, Phone, Search, Users } from "lucide-react";
import { Input } from "@/components/ui/input";
import { PageHeader } from "@/components/Layout";
import { fmtDate, fmtMoney } from "@/components/ticketMeta";
import { api } from "@/lib/api";

const ClientRow = ({ c, index }) => {
  const nav = useNavigate();
  return (
    <button onClick={() => nav(`/clienti/${c.id}`)} data-testid={`client-row-${c.id}`}
      style={{ animationDelay: `${Math.min(index, 12) * 30}ms`, animationFillMode: "both" }}
      className="grid w-full grid-cols-1 gap-3 rounded-xl border bg-card p-4 text-left transition-[border-color,transform] duration-200 hover:-translate-y-0.5 hover:border-primary/50 animate-in fade-in slide-in-from-bottom-2 sm:grid-cols-12 sm:items-center">
      <div className="flex min-w-0 items-center gap-3 sm:col-span-5">
        <div className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-primary/15 font-display font-bold text-primary">{c.name[0]?.toUpperCase()}</div>
        <div className="min-w-0">
          <div className="truncate font-semibold">{c.name}</div>
          <div className="flex flex-wrap gap-x-3 text-xs text-muted-foreground">
            {c.phone && <span className="flex items-center gap-1"><Phone className="h-3 w-3" />{c.phone}</span>}
            {c.address && <span className="flex min-w-0 items-center gap-1 truncate"><MapPin className="h-3 w-3 shrink-0" />{c.address}</span>}
          </div>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2 text-sm sm:col-span-7">
        <div><div className="text-xs text-muted-foreground">Intervenții</div><div className="font-semibold">{c.tickets_count}{c.open_count > 0 && <span className="ml-1 text-xs text-amber-500">({c.open_count} active)</span>}</div></div>
        <div><div className="text-xs text-muted-foreground">Total</div><div className="font-mono font-semibold">{fmtMoney(c.total_cost)}</div></div>
        <div><div className="text-xs text-muted-foreground">Ultimul tichet</div><div className="font-semibold">{fmtDate(c.last_ticket_at)}</div></div>
      </div>
    </button>
  );
};

export default function Clients() {
  const [clients, setClients] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const h = setTimeout(() => {
      setLoading(true);
      api.get("/clients", { params: q.trim() ? { q: q.trim() } : {} }).then((r) => setClients(r.data)).finally(() => setLoading(false));
    }, 250);
    return () => clearTimeout(h);
  }, [q]);

  return (
    <div data-testid="clients-history-view">
      <PageHeader title="Clienți" subtitle="Clienții se adaugă automat la crearea tichetelor." />
      <div className="relative mb-5">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input data-testid="clients-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Caută după nume, telefon sau adresă..." className="h-10 bg-card pl-9" />
      </div>
      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>
      ) : clients.length === 0 ? (
        <div className="rounded-xl border border-dashed py-16 text-center" data-testid="clients-empty">
          <Users className="mx-auto h-10 w-10 text-muted-foreground" />
          <p className="mt-3 font-semibold">Niciun client încă</p>
        </div>
      ) : (
        <div className="space-y-3" data-testid="clients-list">{clients.map((c, i) => <ClientRow key={c.id} c={c} index={i} />)}</div>
      )}
    </div>
  );
}
